import React, { Component } from 'react';
import { translate } from "../Services/translation";
import { SvgPackage } from "../constants";

class QuantityInput extends Component {
    constructor(props) {
        super(props);

        this.hidePopover = this.hidePopover.bind(this);
        this.findBuyButtons = this.findBuyButtons.bind(this);
        this.disableBuyButtons = this.disableBuyButtons.bind(this);
        this.enableBuyButtons = this.enableBuyButtons.bind(this);

        let {
            unitsInBox,
            soldAsBox,
            cartRowSystemId,
            popoverPlacement,
            value
        } = this.props;

        unitsInBox = parseInt(unitsInBox);
        soldAsBox = parseInt(soldAsBox);
        value = parseInt(value);

        this.max = 999;
        this.popoverPlacement = popoverPlacement && popoverPlacement.length ? popoverPlacement : 'bottom';
        this.forcePackageSize = !isNaN(soldAsBox) ? soldAsBox : 0;
        this.min = !isNaN(unitsInBox) && this.forcePackageSize ? unitsInBox : 1;
        this.isCart = typeof cartRowSystemId !== 'undefined' && !!cartRowSystemId.length;

        this.timeouts = {
            popover: null,
            manualChange: null,
        };

        /**
         *
         * @type {{popoverVisible: boolean, value: number}}
         */
        this.state = {
            value: !isNaN(value) ? value : unitsInBox > 1 && isNaN(value) ? unitsInBox : this.min,
            popoverVisible: false,
        };
    }

    /**
     * Stuff to do before re-render.
     *
     * @param nextProps
     * @param nextState
     * @param {any} snapshot
     */
    componentWillUpdate(nextProps, nextState, snapshot) {
        const unitsInBox = this.getUnitsInBox();

        if (nextState.value !== this.state.value) {
            this.resetTimeout('manualChange');

            this.timeouts.manualChange = setTimeout(() => {
                let newValue = nextState.value;
                    newValue = newValue < this.min ? this.min : newValue;
                    newValue = newValue > this.max ? this.max : newValue;

                let oddBox = !Number.isInteger(nextState.value / unitsInBox);
                if (oddBox && this.forcePackageSize) {
                    let newValueCeiled = Math.ceil(newValue / unitsInBox) * unitsInBox;
                    newValue = newValueCeiled > this.max ?
                        Math.floor(newValue / unitsInBox) * unitsInBox:
                        newValueCeiled;
                }

                this.enableBuyButtons();

                let newState = {
                    value: newValue
                }

                if(oddBox && this.forcePackageSize) {
                    newState.popoverVisible = true;
                }

                this.setState(newState);
            }, 500);
        }

        if (this.forcePackageSize) {
            this.resetTimeout('popover');
            this.timeouts.popover = setTimeout(this.hidePopover, 3000);
        }

        if (this.isCart) {
            this.props.cartOnChange(this.props.cartRowSystemId, nextState.value, this.state.value);
        }

        if (!this.isCart) {
            this.enableBuyButtons();
        }
    }

    getUnitsInBox() {
        let { unitsInBox } = this.props;
        unitsInBox = parseInt(unitsInBox);

        return !isNaN(unitsInBox) && unitsInBox > 1 ? unitsInBox : 1;
    }

    /**
     * Reset a timeout
     *
     * @param {string} timeoutProp
     */
    resetTimeout(timeoutProp) {
        if (this.timeouts[timeoutProp] !== null) {
            clearTimeout(this.timeouts[timeoutProp]);
            this.timeouts[timeoutProp] = null;
        }
    }

    /**
     * Hide popover/tooltip by updating the state.
     */
    hidePopover() {
        if (!this.state.popoverVisible) return;

        this.setState({
            popoverVisible: false,
        });
    }

    /**
     *
     * @param {Event|SyntheticEvent} e
     */
    onDecreaseClick(e) {
        let unitsInBox = this.getUnitsInBox();

        let newValue = 0;
        let newCeiledValue = 0;

        let unEvenPackageQty = !Number.isInteger(this.state.value / unitsInBox);
        if (unEvenPackageQty) {
            newCeiledValue = Math.ceil(this.state.value / unitsInBox) * unitsInBox;
        }

        newValue = unEvenPackageQty && unitsInBox > 1 ? newCeiledValue : this.state.value;
        newValue = newValue-unitsInBox;
        newValue = newValue < this.min ? this.min : newValue;

        this.setState({
            value: newValue,
            popoverVisible: !!this.forcePackageSize,
        });
    }

    /**
     *
     * @param {Event|SyntheticEvent} e
     */
    onIncreaseClick(e) {
        let unitsInBox = this.getUnitsInBox();
        let newValue = 0;
        let newValueFloored = 0;

        let unEvenPackageQty = !Number.isInteger(this.state.value / unitsInBox);
        if (unEvenPackageQty) {
            newValueFloored = Math.floor(this.state.value / unitsInBox) * unitsInBox;
        }
        
        newValue = unEvenPackageQty && unitsInBox > 1 ? newValueFloored : this.state.value;
        newValue = newValue+unitsInBox;
        newValue = newValue > this.max ? this.state.value : newValue;

        this.setState({
            value: newValue,
            popoverVisible: !!this.forcePackageSize,
        });
    }

    disableBuyButtons() {
        this.findBuyButtons().forEach(el => {
            el.classList.add('disabled');
        });
    }

    enableBuyButtons() {
        this.findBuyButtons().forEach(el => {
            el.classList.remove('disabled');
        });
    }

    findBuyButtons() {
        const { quantityFieldId } = this.props;
        let selector = `buy-button[data-quantity-field-id="${quantityFieldId}"] a`;
        return document.querySelectorAll(selector);
    }

    /**
     *
     * @param {Event|SyntheticEvent} e
     */
    onChange(e) {
        if (isNaN(parseInt(e.target.value))) {
            this.setState({
                value: '',
                popoverVisible: false,
            });

            return false;
        }

        this.disableBuyButtons();

        this.setState({
            value: parseInt(e.target.value)
        });
    }

    svg(icon, direction = 'increase') {
        if (typeof icon === 'undefined' || icon.trim() === '') return null;

        let svgPath = `/ui/images/icons.svg#${icon}`;
        return (
            <svg className="quantity-input__button_icon" direction={direction} aria-hidden="true" focusable="false">
                <use xlinkHref={svgPath}></use>
            </svg>
        );
    }

    render () {
        const { quantityFieldId } = this.props;

        return (
            <div className="quantity-input">
                <div className="quantity-input__inner-wrapper">
                    <input
                        id={quantityFieldId}
                        value={this.state.value}
                        onChange={e => this.onChange(e)}
                        className="form__input product-detail__quantity-input"
                    />
                    <div className="quantity-input__button-wrapper">
                        <button className="quantity-input__button quantity-input__increase" onClick={e => this.onIncreaseClick(e)}>{this.svg('caret-up')}</button>
                        <button className="quantity-input__button quantity-input__decrease" onClick={e => this.onDecreaseClick(e)}>{this.svg('caret-down', 'decrease')}</button>
                    </div>
                </div>

                {this.state.popoverVisible &&
                    <div className="quantity-input__popover" position={this.popoverPlacement} dangerouslySetInnerHTML={{ __html: translate('product.quantity.roundingnotice')
                        .replace('{quantity}', `<strong>${this.state.value}</strong>`)}}>
                    </div>
                }
            </div>
        );
    }
}

export default QuantityInput;